// extracted by mini-css-extract-plugin
module.exports = {"container":"Skeleton_container__2Q7Zl"};